import React from 'react';
import { Modal} from 'hyperdb-utils';
import { ConfirmModal } from 'hyperdb-utils';
import PriceExtraGuestsForm from './PriceExtraGuestsForm';

class PriceExtraGuests extends React.Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDeleteExtraGuests = this.handleDeleteExtraGuests.bind(this);
    this.state = {};
  }
  render() {
    const props = this.props;
    let extraPeople = props.property.maximum_capacity - props.property.standard_capacity;
    if (extraPeople < 0) extraPeople = 0;
    return (
      <fieldset>
        <legend>
          Charge for nb. extra guests { extraPeople > 0 ? `(${ parseInt(props.property.standard_capacity) + 1}+)` : '' }
          &nbsp;
          <button type="button" className="btn btn-xs btn-primary" onClick={ this.handleToggleModalForm.bind(this, true, -1) }>New</button>
        </legend>
        <div className="table-responsive no-padding">
          <table className="table table-hover table-striped table-bordered table-responsive">
            <thead>
              <tr>
                <th>Nb. extra guests</th>
                <th>Charge</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                (props.prices || []).map((params, i) => {
                  return (
                    <tr key={ i }>
                      <td>{ params.nb_extra_guests }</td>
                      <td>{ params.charge }</td>
                      <td>
                        <button type="button" className="btn btn-xs btn-default" onClick={ this.handleToggleModalForm.bind(this, true, i) }>
                          Edit
                        </button>
                        &nbsp;
                        <button type="button" className="btn btn-xs btn-danger" onClick={ this.handleToggleModalDelete.bind(this, i) }>
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        {
          this.state.showModalExtraGuestsForm
            ? <Modal title={ `Charge for extra guests ${ extraPeople > 0 ? `(${parseInt(props.property.standard_capacity) + 1})+` : ''}` } onClose={ this.handleToggleModalForm.bind(this, false)} onAccept={ this.handleSave }>
                <PriceExtraGuestsForm
                  extraPeople={ extraPeople }
                  params={ this.state.editedExtraGuests }
                  onChange={ this.handleChange }
                />
              </Modal>
            : null
        }
        {
          this.state.showModalDeleteExtraGuests
            ? <ConfirmModal title="Delete price" onClose={ this.handleToggleModalDelete.bind(this, -1)} onConfirm={ this.handleDeleteExtraGuests }>
                Delete this price ?
              </ConfirmModal>
            : null
        }
      </fieldset>
    );
  }

  handleToggleModalForm(bool, indexEditedExtraGuests = -1) {
    const editedExtraGuests = bool && indexEditedExtraGuests !== -1 ? { ...this.props.prices[indexEditedExtraGuests] } : {};
    this.setState({ showModalExtraGuestsForm: bool, indexEditedExtraGuests, editedExtraGuests });
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    const editedExtraGuests = { ...this.state.editedExtraGuests, [attributeName]: value };
    this.setState({ editedExtraGuests });
  }
  handleSave() {
    const prices = (this.props.prices || []).slice();
    const index = this.state.indexEditedExtraGuests;
    const params = this.state.editedExtraGuests;
    if (params.nb_extra_guests) {
      if (index === -1) {
        prices.push(params);
      } else {
        prices[index] = params;
      }
      this.props.onChange({ value: prices });
      this.handleToggleModalForm(false);
    }
  }
  handleToggleModalDelete(props, indexDeleteExtraGuests = -1) {
    const showModalDeleteExtraGuests = indexDeleteExtraGuests !== -1;
    this.setState({ showModalDeleteExtraGuests, indexDeleteExtraGuests });
  }
  handleDeleteExtraGuests() {
    const index = this.state.indexDeleteExtraGuests;
    if (index !== -1) {
      const prices = (this.props.prices || []).slice();
      prices.splice(index, 1);
      this.props.onChange({ value: prices });
      this.handleToggleModalDelete(-1);
    }
  }
};

export default PriceExtraGuests;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/PriceExtraGuests.jsx